import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface ModalQuestionConfig {
  question: string;
  title?: string;
  okText?: string;
  cancelText?: string;
  modalClass?: string;
  icon?: string;
}

@Component({
  selector: 'app-modal-question',
  templateUrl: './modal-question.component.html',
  styleUrls: ['./modal-question.component.sass']
})
export class ModalQuestionComponent {
  private resolve: any;
  private reject: any;

  public config: ModalQuestionConfig = { question: '' };

  constructor(
    public bsModalRef: BsModalRef
  ) { }

  public setOption(resolve: any, reject: any, config: ModalQuestionConfig) {
    this.resolve = resolve;
    this.reject = reject;
    this.config = Object.assign({ question: '', okText: 'OK', cancelText: 'Cancelar' }, config || {});
  }

  public ok(event: Event) {
    this.resolve(true);
    this.reject = null;
    this.bsModalRef.hide();
  }

  public cancel(event: Event) {
    this.reject(false);
    this.bsModalRef.hide();
    // if (this.reject) {
    //   this.reject(false);
    // }
  }
}
